export const SET_SILOS = 'SET_SILOS';
export const SET_TIMERS = 'SET_TIMERS';
export const SET_BREAKDOWNDETECTEDDIALOGOPEN = 'SET_BREAKDOWNDETECTEDDIALOGOPEN';
export const SET_STOPPEDLINE = 'SET_STOPPEDLINE';
export const SET_COUNTER = 'SET_COUNTER';
export const SET_HELPFILESDIALOGOPEN = 'SET_HELPFILESDIALOGOPEN';
export const SET_SCALEDATA = 'SET_SCALEDATA';
